<template>
  <div>
    <!-- Pengurusan Maklumat Menu -->
    <div
      class="pengurusan-maklumat-menu"
      :class="{ open: isPengurusanMaklumatMenuOpen }"
    >
      <ul>
        <!--
          <li class="menu-header">
          <span>PENGURUSAN MAKLUMAT</span>
          </li> 
        -->
        <li>
          <RouterLink to="/pengurusan-maklumat">
            PBTPAY
          </RouterLink>
        </li>
        <!--
          <li>
          <RouterLink to="/pengurusan-maklumat/ePBT">
          ePBT
          </RouterLink>
          </li> 
        -->
      </ul>
    </div>
    <div
      v-if="isPengurusanMaklumatMenuOpen"
      class="overlay"
      @click="closeMenus"
    />
    <button
      v-if="!isPengurusanMaklumatMenuOpen"
      class="pengurusan-maklumat-toggle-button"
      @click="togglePengurusanMaklumatMenu"
    >
      <span class="vertical-text">PENGURUSAN MAKLUMAT</span>
    </button>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const isPengurusanMaklumatMenuOpen = ref(false)

const togglePengurusanMaklumatMenu = () => {
  isPengurusanMaklumatMenuOpen.value = !isPengurusanMaklumatMenuOpen.value
  if (isPengurusanMaklumatMenuOpen.value) {
    closeMainMenu()
  }
}

const closeMenus = () => {
  isPengurusanMaklumatMenuOpen.value = false
  closeMainMenu()
}

const closeMainMenu = () => {
  // Emit event to close Main Menu
  const event = new CustomEvent('close-main-menu')

  window.dispatchEvent(event)
}

window.addEventListener('close-pengurusan-maklumat-menu', () => {
  isPengurusanMaklumatMenuOpen.value = false
})
</script>

<style scoped>
/* Pengurusan Maklumat Menu */
.pengurusan-maklumat-menu {
  position: fixed;
  top: 30%;
  right: 0;
  width: 200px;
  height: auto;
  max-height: 70%;
  background-color: #312867;
  color: white;
  padding: 10px 15px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s;
  transform: translateX(100%);
  z-index: 1000;
  border-radius: 10px;
}

.pengurusan-maklumat-menu.open {
  transform: translateX(0);
}

.pengurusan-maklumat-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.pengurusan-maklumat-menu li {
  margin-bottom: 10px;
}

.pengurusan-maklumat-menu a,
.pengurusan-maklumat-menu router-link {
  color: white;
  text-decoration: none;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

/* Pengurusan Maklumat Toggle Button */
.pengurusan-maklumat-toggle-button {
  position: fixed;
  top: 40%;
  right: -10px;
  transform: translateY(-50%);
  background-color: #312867;
  border: none;
  padding: 2px;
  border-radius: 5px 0 0 5px;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  z-index: 100;
  transition: right 0.3s;
  writing-mode: vertical-rl;
  text-orientation: mixed;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
}

.pengurusan-maklumat-toggle-button .vertical-text {
  writing-mode: vertical-rl;
  text-orientation: mixed;
}

.menu-header {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.2rem;
  font-weight: bold;
}
</style>
